import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-container mt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "dialog-content mt-6"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 2,
  class: "v-limit-slider v-locale--is-ltr"
}
const _hoisted_5 = {
  key: 0,
  class: "divider"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = {
  key: 2,
  class: "dialog-content pb-6"
}

import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { formApi } from '@/api/form';
import { useErrors } from '@/utils/use-errors';
import { useDialogStore } from '@/stores/dialogs';
import { useProgramsStore } from '@/stores/programs';
import formData from '@/utils/test.json'
import VDialogHeader from './VDialogHeader.vue';
import VLimitTag from '../VLimitTag.vue';
import SuccesDialog from './SuccesDialog.vue';
import { useUiStore } from '@/stores/ui';

type Column = { id: string, name: string, type: string, choises?: { [key: string]: string }, info?: { [key: string]: string } }

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateLimitsReportDialog',
  props: {
    report: null
  },
  setup(__props: any) {

const props = __props as { report?: any }


const columns = reactive<Column[]>([])

const status = ref<"init" | "loaded">("init")

const values = reactive<any>({})

const meta = computed(() => {
  const obj: any = {}
  for (let item of programsStore.limitsMeta) {
    obj[item.title] = item
  }
  return obj
})

let multiselectFields: string[] = []
onMounted(async () => {
  const formData = await formApi.getFormData("shrlzL6Fgcywizhev")

  columns.length = 0
  for (let data of formData.columns) {
    const name = data.metadata?.title || data.name
    const type = data.type
    const id = data.name
    const column: Column = { id, name, type  }
    
    if (data.typeOptions?.choices) {
      let arr = data.typeOptions.choiceOrder.map((id: string) => [ id, (data.typeOptions!.choices as any)[id].name ] )
      column.choises = Object.fromEntries(arr)
    }
    
    if (data.metadata?.description) {
      column.info = {}
      let str = data.metadata?.description!
      if (str.startsWith("-")) {
        const i2 = str.indexOf("-", 1)
        const tag = str.slice(1, i2)
        str = str.slice(i2+1).trim()
        column.info.tag = tag
      }
      column.info.description = str
    }

    if (type === "number") {
      values[id] = 0
    }
    if (type === 'foreignKey') {
      multiselectFields.push(id)
    }
     
    columns.push(column)
  }

  if (props.report) {
    values['Программа'] = props.report.programId
    await nextTick()
    values['Команда'] = props.report.teamId
    await nextTick()
    for (let [ key, value ] of Object.entries(props.report.fields)) {
      values[key] = value
    }
    const ids = Object.entries(columns.find(column => column.id === "Ключевое ограничение")!.choises!).find((i: any) => i[1] === props.report.keyLimit)
    if (ids) {
      values["Ключевое ограничение"] = ids[0]
    }
    
  }

  status.value = "loaded"
})

const programsStore = useProgramsStore()
const teams = ref()
watch(() => values["Программа"], (programId) => {
  if (!programId) return
  const program = programsStore.programs.find(item => item.id === programId)
  teams.value = program?.teams || []
  if (values["Команда"] && !teams.value.find((item: any) => item.id === values["Команда"])) {
    delete values["Команда"]
  }
})


const getSelectItems = (name: string) => {
  if (name === "Программа") {
    return programsStore.programs
  }
  if (name === "Команда" || name === "Название команды") {
    return teams.value
  }
  if (name === "Новая контрольная точка") {
    return programsStore.stages
  }
  return []
}

const team = computed(() => {
  const program = programsStore.programs.find(item => item.id === values["Программа"])
  if (!program) return null
  const team = program.teams.find(team => team.id === values["Команда"])
  return team || null
})

const uiStore = useUiStore()

const dialogStore = useDialogStore()
const pending = ref(false)
const errors = useErrors(values)
const ignore = [ "Комментарий к ограничению" ]

const submit = async () => {
  pending.value = true
  try {
    let hasError = false
    for (let column of columns) {
      if (typeof values[column.id] !== "number" && !values[column.id] && !ignore.includes(column.id)) {
        errors[column.id] = "Поле обязательно к заполнению"
        hasError = true
      }
    }
    if (hasError) {
      console.log(errors)
      return false
    }
    const _values = { ...values }
    for (let [ name, value ] of Object.entries(_values)) {
      if (multiselectFields.includes(name) && !Array.isArray(value)) {
        _values[name] = [ value ]
      }
    }

    if (props.report) {
      await formApi.sendLimitFormEdit(props.report.id, _values)
      dialogStore.open(SuccesDialog, { title: "Отчет сохранен", content: "Данные обновлены" })
    } else {
      await formApi.sendLimitForm(_values)
      dialogStore.open(SuccesDialog, { title: "Отчет отправлен", content: "Спасибо за проделанную работу!" })
    }
    const _team = team.value!
    setTimeout(() => {
      programsStore.requestReports(_team)
    }, 1500)

  } finally {
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VDialogHeader, null, {
      default: _withCtx(() => [
        (props.report)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Редактирование отчета")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Создание отчета по ограничениям")
            ], 64))
      ]),
      _: 1
    }),
    (status.value === 'init')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (column.type === 'foreignKey')
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    modelValue: values[column.id],
                    "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                    "error-messages": _unref(errors)[column.id],
                    items: getSelectItems(column.name),
                    label: column.name,
                    "item-title": "name",
                    "item-value": "id",
                    variant: "outlined"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "items", "label"]))
                : (column.type === 'select')
                  ? (_openBlock(), _createBlock(_component_v_select, {
                      key: 1,
                      modelValue: values[column.id],
                      "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                      "error-messages": _unref(errors)[column.id],
                      items: Object.entries(column.choises!),
                      label: column.name,
                      "item-title": "1",
                      "item-value": "0",
                      variant: "outlined"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "items", "label"]))
                  : (column.type === 'number')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (column.info?.tag)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                          : _createCommentVNode("", true),
                        (column.info?.tag)
                          ? (_openBlock(), _createBlock(VLimitTag, {
                              key: 1,
                              title: column.info.tag
                            }, null, 8, ["title"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                          _createTextVNode(_toDisplayString(column.name) + " ", 1),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-help-circle-outline",
                            size: "small",
                            onClick: ($event: any) => (_unref(uiStore).openTooptip($event, _unref(meta)[column.id]?.fields['Описание']))
                          }, null, 8, ["onClick"])
                        ]),
                        _createVNode(_component_v_slider, {
                          modelValue: values[column.id],
                          "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                          "track-size": "6",
                          "thumb-size": "14",
                          min: 0,
                          max: 5,
                          step: "1",
                          "show-ticks": "always",
                          "tick-size": "0",
                          "hide-details": "",
                          ticks: [ 0, 1, 2, 3, 4, 5 ],
                          class: "mb-6"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(meta)[column.id]?.fields["Оценка "+values[column.id]] || column.info?.description), 1)
                      ]))
                    : (column.type === 'multilineText')
                      ? (_openBlock(), _createBlock(_component_v_textarea, {
                          key: 3,
                          modelValue: values[column.id],
                          "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                          rows: "2",
                          variant: "outlined",
                          label: column.name,
                          color: "primary",
                          "error-messages": _unref(errors)[column.id]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                      : (_openBlock(), _createBlock(_component_v_text_field, {
                          key: 4,
                          modelValue: values[column.id],
                          "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                          variant: "outlined",
                          label: column.name,
                          "error-messages": _unref(errors)[column.id]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
            ]))
          }), 256))
        ])),
    (status.value === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: _unref(dialogStore).close,
            variant: "tonal",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Отменить")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            color: "primary",
            disabled: pending.value,
            onClick: submit
          }, {
            default: _withCtx(() => [
              (props.report)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Сохранить")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Отправить")
                  ], 64))
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})